import { createContext } from 'react';

export const ScreenshotDataContext = createContext<{
  isAllDataForScreenshotLoaded: boolean;
  setSlideIsReady: (ready: boolean) => void;
}>({
  isAllDataForScreenshotLoaded: false,
  setSlideIsReady: () => {},
});

export const ScreenshotDataProvider = ScreenshotDataContext.Provider;
